import React from "react";
import {
  DialogContent,
  withStyles,
  Dialog,
  List,
  ListItem,
  ListSubheader,
  IconButton,
  Button,
} from "@material-ui/core";
import { getImagesFromBlobStorage, PRO_IMAGES, STOP_IMAGES } from "./getBlobImages";
import {
  ProImagesTabPanel,
  StopImagesTabPanel,
  LoadingView,
} from "./TabPanels";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import CloseIcon from "@material-ui/icons/Close";
import { trackEvent } from "../../../../../common/AppInsightsEventTracking";
import { getDataWithQueryString } from "../../../../../../api/componentAPIs";
import { DescriptionOutlined, Refresh } from "@material-ui/icons";
import StyledSelect from "../../../../../common/StyledSelect";
import { base64toBlob, getProImagesCount, getStopsList } from "./utils";
import IBplanningProImages from "./IBPlanningProImages";
import { getProNumbers } from "../utils";
import { isEqual } from "lodash/lang";
import { FILE_TYPES } from "./constants";

const styles = (theme) => ({
  imageListContainer: {
    flex: 0.5,
  },
  imageContainer: {
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    height: "95%",
  },
  loadingLabel: {
    fontSize: theme.textFontSize,
    color: theme.HeaderSelectedText,
  },
  imageGroupTitle: {
    fontSize: 20,
    color: theme.HeaderSelectedText,
  },
  dialogWrapper: {},
  dialog: {
    backgroundColor: theme.ModalBGColor,
    height: "65%",
    width: "50%",
    minHeight: 600,
    minWidth: 900,
  },
  dialogContent: {
    display: "flex",
    padding : 24,
  },
  listSubHeader: {
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    cursor: "default",
    padding: "0px 8px 8px 8px",
    color: theme.TextColor,
    fontWeight: 600,
    textTransform : "uppercase"
  },
  listItem: {
    fontSize: theme.headerTextFontSize,
    cursor: "pointer",
    color: theme.ColumnHeaderTextColor,
    textTransform: "capitalize",
    padding: "8px 20px",
    "&$listItemSelected, &$listItemSelected:hover, &$listItemSelected:focus": {
      backgroundColor: theme.HeaderSelectedText,
    },
    display: "flex",
    justifyContent: "space-between",
    minWidth: 180,
  },
  listItemSelected: {
    backgroundColor: theme.HeaderSelectedText,
    color: theme.white,
  },
  closeButtonContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "4px 8px 8px 32px",
    alignItems: "center",
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  imagesContainer: {
    flex: 1,
    paddingLeft: 24,
    paddingBottom: 24,
    overflow: "hidden",
  },
  closeButton: {
    color: theme.iconColor,
  },
  refreshButton: {
    marginRight: 4,
    "& span": {
      marginLeft: 4,
    },
  },
  center: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  error: {
    color: theme.error,
  },
  message: {
    opacity: 0.5,
  },
  dropDownContainer: {
    display: "flex",
    alignItems: "center",
    width: "50%",
  },
  headerText: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    minWidth: 100,
  },
  dropdownInput: {
    padding: "4px 0px",
  },
  eDRPlaceholderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 224,
    width: 168,
    cursor: "pointer",
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "2px",
  },
  descriptionIcon : {
    color : theme.iconColor
  },
  label : {
    color: theme.gridTextColor,
    textTransform: "capitalize",
    margin: "12px 0",
  }
});

class StopImagesDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      proImages: "",
      stopImages: "",
      showImages: this.props.showImages,
      fetchError: false,
      imageURLData: {},
      loading: true,
      stopId: "",
      stopsList : [],
      eDRData : {}
    };
  }

  componentDidMount() {
    if (this.props.stopId) {
      this.setState({
        stopId: this.props.stopId,
        stopsList : getStopsList(this.props.stops),
        proNumbers: this.props.proNumbers.length
          ? this.props.proNumbers
          : this.getSelectedStopProNumbers(this.props.stopId),
        ...(!this.props.isStopCompleted && {loading: false})
      });
      if (this.props.isStopCompleted) {
        this.getImageData(this.props.stopId);
      }
    }
    trackEvent("ViewStopImages", this.props.userProfile, {
      terminalCode: this.props.terminalCode,
      routeId: this.props.routeId,
      stopId: this.props.stopId,
      eventDateTime: new Date(),
    });
  }

  componentDidUpdate(prevProps){
    if(!isEqual(prevProps.stops, this.props.stops)){
      this.setState({
        stopsList: getStopsList(this.props.stops),
      });
    }
  }

  getSelectedStopProNumbers = (stopId) => {
    const stopData = this.props.stops.find(
      (stop) => stop.stopId === stopId
    );
    return stopData ? getProNumbers(stopData.shipments) : [];
  }

  getImageData = (stopId) => {
    getDataWithQueryString(
      "GetImages",
      `terminalCode=${this.props.terminalCode}&stopId=${stopId}&routeId=${this.props.routeId}`
    ).then(
      (response) => {
        if (response && response.status === 200) {
          this.setState({
            imageURLData: response.data,
            fetchError: false,
          });
          this.fetchBlobImages(response.data);
        } else {
          this.handleError();
        }
      },
      (_error) => {
        this.handleError();
      }
    );
  };

  hideLoader = () => {
    this.setState({
      loading: false,
    });
  };

  fetchBlobImages = (imageData) => {
    const { showImages, proImages, stopImages, eDRData } = this.state;
    if (this.state.proNumbers.includes(showImages)) {
      const proData = imageData?.pros?.find((pro) => pro.proId === showImages);
      !proImages[showImages]
        ? getImagesFromBlobStorage({
            folderName: showImages,
            updateFunction: this.setProImages,
            handleError: this.handleError,
            imageData: proData?.proImages ?? {},
            fileType : FILE_TYPES.IMAGE
          })
        : this.hideLoader();
        if(!eDRData[showImages] && proData?.eDR) {
          getImagesFromBlobStorage({
            folderName: showImages,
            updateFunction: this.setEDR,
            handleError: this.handleError,
            imageData: { eDR: [proData?.eDR] },
            fileType: FILE_TYPES.PDF
          });  
        } 
      return;
    }
    !stopImages[showImages]
      ? getImagesFromBlobStorage({
          folderName: showImages,
          imageData: {
            [showImages]: imageData?.stopImages?.[showImages] ?? [],
          },
          updateFunction: this.setStopImage,
          handleError: this.handleError,
          fileType: FILE_TYPES.IMAGE,
        })
      : this.hideLoader();
  };

  setProImages = (proNumber, value) => {
    this.setState((state) => ({
      ...state,
      loading : false,
      proImages: {
        ...(state.proImages ?? {}),
        [proNumber]: value,
      },
    }));
  };

  setEDR = (proNumber, value) => {
    this.setState((state) => ({
      ...state,
      loading : false,
      eDRData: {
        ...(state.eDRData ?? {}),
        [proNumber]: value,
      },
    }));
  };

  setStopImage = (stopId, value) => {
    this.setState((state) => ({
      ...state,
      loading : false,
      stopImages: {
        ...state.stopImages,
        ...value,
      },
    }));
  };

  showImages = (event) => {
    const showImages = event.target.getAttribute("data-value");
    if (showImages && showImages !== this.state.showImages) {
      this.setState({ showImages, loading: true, fetchError: false }, () =>
        this.fetchBlobImages(this.state.imageURLData)
      );
    }
  };

  getStopImagesList = () => {
    // Updates the stop images list which are not listed in STOP_IMAGES
    const stopImagesKeys = Object.keys(STOP_IMAGES);
    const additionalStopImages = Object.keys(
      this.state.imageURLData?.stopImages || {}
    ).reduce((stopImage, stopImageKey) => {
      if (!stopImagesKeys.includes(stopImageKey)) {
        stopImage[stopImageKey] = stopImageKey;
      }
      return stopImage;
    }, {});

    return {
      ...STOP_IMAGES,
      ...additionalStopImages,
    };
  };

  refreshImageData = () => {
    this.props.refreshDriverRouteData?.();
    const isStopCompleted = this.props.stops.find(
      (stop) => stop.stopId.toLowerCase() === this.state.stopId?.toLowerCase()
    )?.isStopCompleted;
    if (isStopCompleted) {
      this.setState({
        fetchError: false,
        proImages: "",
        stopImages: "",
        loading : true,
        imageURLData : {}
      });
      this.getImageData(this.state.stopId);
    }
  };

  handleError = () => {
    this.setState({
      loading: false,
      fetchError: true,
    });
  };

  handleStopChange = (value) => {
    const stopId = value.value;
    if (stopId !== this.state.stopId) {
      const proNumbers = this.getSelectedStopProNumbers(stopId);
      this.setState(
        {
          stopId,
          fetchError: false,
          proNumbers,
          proImages: "",
          stopImages: "",
          imageURLData: {},
          loading: value.isStopCompleted? true : false,
          showImages : proNumbers[0] || Object.keys(STOP_IMAGES)[0],
          eDRData : {}
        },
        () => {
          if (value.isStopCompleted) {
            this.getImageData(stopId)
          }
        }
      );
    }
  };

  openEDR = () => {
    const {
      showImages,
      eDRData,
    } = this.state;
    const blob = base64toBlob(eDRData[showImages]?.eDR[0]);
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL);
  }

  render() {
    const {
      proImages,
      stopImages,
      showImages,
      fetchError,
      proNumbers,
      stopsList,
      imageURLData,
      stopId,
      eDRData
    } = this.state;
    const { classes } = this.props;
    const { theme } = this.props.userData.userProfile || {};
    const stopImagesList = this.getStopImagesList();
    return (
      <Dialog
        open={true}
        maxWidth={false}
        scroll={undefined}
        classes={{ paper: classes.dialog }}
        className={`${classes.dialogWrapper} ${
          theme === "dark" ? "darkTheme" : "lightTheme"
        } `}
      >
        <div className={classes.closeButtonContainer}>
          <div className={classes.dropDownContainer}>
            <span className={classes.headerText}>Stop Images</span>
            {stopId && <StyledSelect
              data={stopsList}
              textFieldProps={{
                id: "stop",
                variant: "outlined",
                label: "",
              }}
              onChange={this.handleStopChange}
              value={stopId}
              isNotClearable
              InputPropsClasses={{
                input: classes.dropdownInput,
              }}
            />}
          </div>
          <div>
            {stopId &&<Button
              variant="outlined"
              color="primary"
              onClick={this.refreshImageData}
              className={classes.refreshButton}
            >
              <Refresh /> <span>Refresh</span>
            </Button>}
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={this.props.close}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <DialogContent classes={{ root: classes.dialogContent }}>
          {!stopId ? (
            <div className={`${classes.center} ${classes.message}`}>
              Not Available
            </div>
          ) : (
            <>
              <div>
                <List onClick={this.showImages}>
                  <ListSubheader className={classes.listSubHeader}>
                    Pro Images
                  </ListSubheader>
                  {proNumbers.map((proNumber) => {
                    const proImagesCount = getProImagesCount(proNumber, imageURLData?.pros)
                    return (
                      <ListItem
                        key={proNumber}
                        classes={{
                          root: classes.listItem,
                          selected: classes.listItemSelected,
                        }}
                        data-value={proNumber}
                        selected={showImages === proNumber}
                      >
                        {proNumber}
                        {proImagesCount && <span>({proImagesCount})</span>}
                      </ListItem>
                    );})}
                  <br /> <br /> <br />
                  <ListSubheader className={classes.listSubHeader}>
                    Stop Images
                  </ListSubheader>
                  {Object.keys(stopImagesList).map((imageNameKey) => {
                    const stopImagesCount = imageURLData?.stopImages?.[imageNameKey]?.length
                    return (
                      <ListItem
                        key={imageNameKey}
                        classes={{
                          root: classes.listItem,
                          selected: classes.listItemSelected,
                        }}
                        data-value={imageNameKey}
                        selected={showImages === imageNameKey}
                      >
                        {stopImagesList[imageNameKey]}
                        {stopImagesCount && <span>({stopImagesCount}) </span>}
                      </ListItem>
                    );})}
                </List>
              </div>
              <div className={classes.imagesContainer}>
                <div className={`${classes.imageContainer} customScroll`}>
                  {this.state.loading && (
                    <LoadingView
                      label="Loading Images"
                      labelClass={classes.loadingLabel}
                    />
                  )}
                  {proNumbers.includes(showImages) &&
                  eDRData[showImages]?.eDR ? (
                    <>
                      <div className={classes.label}>
                        {PRO_IMAGES.edr}
                      </div>
                      <div
                        className={classes.eDRPlaceholderContainer}
                        onClick={this.openEDR}
                        >
                            <DescriptionOutlined className={classes.descriptionIcon} fontSize="large" />
                      </div>
                    </>
                  ) : null}
                  {fetchError && (
                    <div className={`${classes.center} ${classes.error}`}>
                      Error while fetching images
                    </div>
                  )}
                  {!this.state.loading && !fetchError && (
                    <>
                      {stopImages && !proImages[showImages] ? (
                        <StopImagesTabPanel
                          label={stopImagesList[showImages]}
                          stopImages={stopImages[showImages]}
                        />
                      ) : null}

                      {proImages && proImages[showImages] ? (
                        <ProImagesTabPanel proImages={proImages[showImages]} />
                      ) : null}
                    </>
                  )}
                  {proNumbers.includes(showImages) ? (
                    <IBplanningProImages proNumber={showImages} />
                  ) : null}
                </div>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

export default compose(withUserProfile, withStyles(styles))(StopImagesDialog);
